<template>
  <div id="dialogSix">
    <div class="h-dialogContainer">
      <div class="row">
        <div class="col-sm-4">
          <div class="h-borderBox height-280">
            <div class="h-borderTree-top">{{$t('Pm.measurementObject')}}</div>
            <div class="h-borderTree-content">
              <MeasureObjTree ref="measureObjTree" @selectMeasureEmit="selectMeasureEmit"></MeasureObjTree>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="h-borderBox height-280">
            <div class="h-borderTree-top">{{$t('Pm.measuringPosition')}}</div>
            <div class="h-borderTree-content">
              <seatTree ref="seatTree"></seatTree>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="h-borderBox height-280">
            <div class="h-borderTree-top">{{$t('Pm.indicator')}}</div>
            <div class="h-borderTree-content">
              <IndicatorTree ref="indicatorTree"></IndicatorTree>
            </div>
          </div>
        </div>
      </div>
      <div class="h-marginT28">
        <div>
          <div class="h-borderBox h-borderBox-input">
            <div class="row h-row-inputBox">
              <div class="col-sm-5 h-col-inputBox">
                <div class="h-inputLit">{{$t('Pm.samplingPeriod_unit')}}</div>
                <ejs-numerictextbox ref="period" value="5" :min="5" :max="59"></ejs-numerictextbox>
              </div>
              <div class="col-sm-5 h-col-inputBox">
                <div class="h-inputLit">{{$t('Pm.taskDuration')}}</div>
                <ejs-timepicker
                  id="timepicker"
                  v-model="timepickerValue"
                  :step="interval"
                  :format="customFormat"
                  :allowEdit=false
                  :min="minDate"
                ></ejs-timepicker>
              </div>
            </div>
            <div class="row h-row-inputBox">
              <div class="col-sm-5 h-col-inputBox">
                <div class="h-inputLit">{{$t('Pm.saveDataOrNot')}}</div>
                <ejs-radiobutton ref="saveFileRadio" :label='$t("Pm.yes")' name="savefile" value="1"></ejs-radiobutton>
                <ejs-radiobutton :label='$t("Pm.no")' name="savefile" value="0" checked="true"></ejs-radiobutton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MeasureObjTree from '../MeasureObjTree';
import seatTree from '../seatTree';
import IndicatorTree from '../IndicatorTree';
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: 'AddTaskDialog',
  data() {
    return {
      timepickerValue: this.taskDurationValue(),
      interval: 1,
      customFormat: 'HH:mm:ss',
      minDate: new Date("05/27/2017 00:01:00")
    };
  },
  components: {
    MeasureObjTree,
    seatTree,
    IndicatorTree
  },
  computed: {},
  methods: {
    // 选择测量对象后，触发测量位置和测量指标树
    selectMeasureEmit(args) {
      this.$refs.seatTree.getSeatTree(args);
      this.$refs.indicatorTree.getIndicatorTree(args);
    },
    // 初始化任务时长数值
    taskDurationValue() {
      let date = new Date();
      date.setHours(0);
      date.setMinutes(10);
      date.setSeconds(0);
      return date;
    },
    pkgParams() {
      // 测量对象
      let measureObj = this.$refs.measureObjTree.getSelectMeasureInfo();
      if(measureObj == undefined){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMOplease') });
        return;
      }

      // 测量位置
      let measureSeats = this.$refs.seatTree.getSeleceSeatTreeInfo();
      if (!measureSeats || measureSeats.length <= 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMSeatPlease') });
        return;
      }
      let seats = this.getSeatsFromPage(measureObj, measureSeats);
      // 测量指标
      let indicators = this.$refs.indicatorTree.getSeleceIndicatorTreeInfo();
      if (!indicators || indicators.length == 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectIndicatorPlease') });
        return;
      }

      // 任务类型
      let taskType = undefined;
      // 任务时长
      let duration = undefined;

      try {
        duration =
          this.timepickerValue.getHours() * 3600 +
          this.timepickerValue.getMinutes() * 60 +
          this.timepickerValue.getSeconds();
      } catch {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.fillCorrectTaskDuration') });
        return;
      }


      // 是否保存数据
      let saveFile = this.$refs.saveFileRadio.ej2Instances.checked ? 1 : 0;
      // 采集周期
      let period = parseInt(this.$refs.period.getText());

      let params = {};
      params.duration = duration;
      params.saveAsFile = saveFile;
      params.period = period;
      params.taskType = taskType;
      params.measureObj = measureObj.attributes;
      params.measureSeats = seats;
      params.indicators = [];

      for (let i = 0; i < indicators.length; i++) {
        params.indicators.push(indicators[i].attributes);
      }

      // 验证数据完整性
      if (!params.measureObj || !params.measureObj.counterTypeId) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMOplease') });
        return;
      }

      // 验证数据完整性
      if (!params.indicators || params.indicators.length == 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectIndicatorPlease') });
        return;
      }

      // 验证数据完整性
      if (!params.measureSeats || params.measureSeats.length == 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMSeatPlease') });
        return;
      }

      // 验证数据完整性
      if (!params.period) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.fillInSamplingPeriod') });
        return;
      }

      return params;
    },
    getSeatsFromPage(measureObj, measureSeats) {
      var seats = [];
      var childNeTypeId = parseInt(
        measureObj.attributes.measureObjectTypeCode.substr(0, 3)
      );

      switch (parseInt(measureObj.attributes.neTypeId)) {
        // eNodeB
        case 101:
          if('101103' === measureObj.attributes.measureObjectTypeCode){
            seats = this.getMeasureSeatsId2(measureSeats);
          }else {
            seats = this.getMeasureSeatsId1(measureSeats);
          }
          break;
        // BPDT
        case 134:
          seats = this.getMeasureSeatsId1(measureSeats);
          break;

        // EPC部分
        case 102:
        case 103:
        case 104:
        case 105:
        case 115:

        // MBMS部分
        case 117:
        case 118:

        // MCS无实时指标

        // IMS部分
        case 106:
        case 107:
        case 114:
        case 116:
        case 132:
        case 133:
          seats = this.getMeasureSeatsId2(measureSeats);
          break;
        case 108:
          break;
        case 109:
          break;
        case 110:
          break;

        // iBS部分
        case 150:
          if (childNeTypeId === 101) {
            seats = this.getMeasureSeatsId1(measureSeats);
          } else {
            seats = this.getMeasureSeatsId2(measureSeats);
          }
          break;
      }
      return seats;
    },
    getMeasureSeatsId1(measureSeats) {
      let seats = [];
      const regex = /_SCTP_\d+/g;
      for (let i = 0; i < measureSeats.length; i++) {
        seats.push(measureSeats[i].parentId + '_' + measureSeats[i].id.replace(regex, ''));
      }
      return seats;
    },
    getMeasureSeatsId2(measureSeats) {
      let seats = [];
      const regex = /_SCTP_\d+/g;
      for (var i = 0; i < measureSeats.length; i++) {
        seats.push(measureSeats[i].id.replace(regex, ''));
      }
      return seats;
    }
  }
};
</script>

<style>
</style>
